import {Component, OnInit} from '@angular/core';
import {BusinessProfilesHttpService} from '../../../services/http-services/business-profiles/business-profiles-http.service';
import {ActivatedRoute} from '@angular/router';
import {BusinessProfileTabs} from '../../../enums/business-enums';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {GeneralHttpService} from '../../../services/http-services/general/general-http.service';
import {UsersHttpService} from "../../../services/http-services/users/users-http.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'gr-business-profile',
  templateUrl: './business-profile.component.html',
})
export class BusinessProfileComponent implements OnInit {
  isBusinessApproved: null | boolean = null;
  listOfCategories: any[] = [];
  urlParams = { companyId: null };
  businessProfileTabs = BusinessProfileTabs;
  activeTab = BusinessProfileTabs.baseData;
  isBusinessProfileRequestFinished = false;
  businessData: any;
  isNewBusiness = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  categoryId: any;

  constructor(private businessProfilesHttpService: BusinessProfilesHttpService,
              private generalHttpService: GeneralHttpService,
              private activatedRoute: ActivatedRoute,
              private usersHttpService: UsersHttpService,
              private toastService: ToastrService
              ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((res: any) => {
      this.categoryId = history.state.categoryId;
      console.log(' this.categoryId',  this.categoryId)
      this.isNewBusiness = history.state.isNewBusiness === null;
      this.urlParams.companyId = res.id;
      this.getBusinessProfile();
      this.getCategories();
    });
  }

  getBusinessProfile(): void {
    this.isBusinessProfileRequestFinished = false;
    this.businessProfilesHttpService.getSingleBusiness(this.urlParams).then(res => {
      this.isBusinessApproved = res.data.approved;
      this.businessData = res.data;
      this.isBusinessProfileRequestFinished = true;
    });
  }

  getCategories(): void {
    this.generalHttpService.getBusinessCategories().then(res => {
      this.listOfCategories = res.data;
    });
  }

  approveOrRejectBusinessProfile(approve: number): void {
    this.isBusinessApproved = !!approve;
    this.businessProfilesHttpService.putApproveBusiness(this.urlParams, {approve}).then(res => {});
  }

  approveUser(): void {
    this.usersHttpService.approveUser(this.businessData.user.id).then(res => {
      this.getBusinessProfile();
      this.toastService.success(res.message);
    }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
      Object.values(error.errors).forEach(error => this.toastService.error(error));
    });
  }
}
